module.exports = __webpack_public_path__ + "img/trabzonspor-logo-icon.7f48ce52.png";